// ─── Environment detection ────────────────────────────────────────────

type AppEnv = 'production' | 'staging' | 'local';

const detectEnv = (): AppEnv => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'local';
  if (hostname.startsWith('stg-')) return 'staging';
  return 'production';
};

const ENV: AppEnv = detectEnv();

const KEY_PREFIX = ENV === 'staging' ? 'stg_' : '';
const prefixKey = (key: string): string => `${KEY_PREFIX}${key}`;

// ─── Auth keys cleared on sign-out ───────────────────────────────────

const AUTH_KEYS = ['token', 'profile'];

// ─── AppStorage — pure localStorage implementation ───────────────────

class AppStorage {
  setItem(key: string, value: string): void {
    if (typeof window !== 'undefined') {
      localStorage.setItem(prefixKey(key), value);
    }
  }

  getItem(key: string): string | null {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(prefixKey(key));
    }
    return null;
  }

  removeItem(key: string): void {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(prefixKey(key));
    }
  }

  clear(): void {
    AUTH_KEYS.forEach((key) => this.removeItem(key));
  }
}

export const storage = new AppStorage();

export const getUserData = () => {
  try {
    const raw = storage.getItem('profile');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const getUserEmail = (): string => {
  const userData = getUserData();
  return userData?.email || 'user@dashelectric.co';
};
